import { Box, Container } from "@mui/material";
import BloqueVista from "../../components/public/BloqueVista";
import { sxColumnaContenido } from "../../components/public/ContenidoNavegable";

/** Página pública "Preguntas Frecuentes": el bloque "preguntas" —largo, con
 *  índice al lado— y, al final, los coordinadores, alineados con la columna de
 *  lectura. La misma vista dentro de la app está en `pages/app/Preguntas`. */
export default function Preguntas() {
  return (
    <Container maxWidth={false} sx={{ maxWidth: 1160, py: { xs: 5, md: 7 }, minHeight: "55vh" }}>
      <BloqueVista clave="preguntas" conIndice />
      <Box sx={sxColumnaContenido}>
        <BloqueVista clave="coordinadores" alPie />
      </Box>
    </Container>
  );
}
